import { EmailNotification } from "./complaint-email-notification.model";

/**Cliente de reclamo */
export class ComplaintClient {
    /**Nombre */
    public name: string;
    /**Apellidos */
    public lastName: string;
    /**Tipo de documento */
    public documentType: string;
    /**Número de documento */
    public documentNumber: string;
    /**Teléfono fijo */
    public homePhone: string;
    /**Celular */
    public cellPhone: string;
    /**Correo electrónico */
    public emailAddress: string;
    /**Tipo de cliente */
    public type: string;
    /**Código de cliente */
    public code: string;
    /**Número de instalación */
    public installationNumber: string;
    /**Id de Interlocutor  */
    public interlocutorId: string;
   
}